import React from 'react';

interface BaseIconProps {
  children: React.ReactNode;
  className?: string;
  strokeWidth?: number;
}

const BaseIcon: React.FC<BaseIconProps> = ({ children, className = "w-4 h-4", strokeWidth = 1.5 }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth={strokeWidth} 
    strokeLinecap="round" 
    strokeLinejoin="round" 
    className={`${className} transition-colors duration-200`}
  >
    {children}
  </svg>
);

export default BaseIcon;
